import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { YSButton } from "../../uikit/YSButton";
import VideocamIcon from "@mui/icons-material/Videocam";
import { ContentStyle, HelpCardStyle } from "../../Theme";
import { useState } from "react";
import { DialogPopup } from "../../components/DialogPopup";
import LinkIcon from "@mui/icons-material/Link";
import DRxInput from "../../uikit/DRxInput";
import { Form, Formik } from "formik";
import { requestForDemoEmailSendAPI } from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import { REPORT_BASE_URL } from "../../Apis/Constants";

const HelpCenterData = [
  {
    title: "MFA from H2H DigitalRx Application",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/DigitalRx_IDME_MFA_User_Manual_v1.0.pdf `,
        label: "Document",
      },
    ],
    videos: [
      {
        videoId: "I9776v5VEPg",
        label: "Video",
      },
    ],
  },
  {
    title: "DRx User Manual v3.1",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/DigitalRx-UserManual-v3.1.pdf`,
        label: "Document",
      },
    ],
  },
  {
    title: "Medical Adherence User Guide",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/H2H_DigitalRx_Medical_Adherence_User_Manual_v1.0.pdf`,
        label: "Document",
      },
    ],
  },
  {
    title: "PDMP Step By Step User Guide",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/H2H-DRx-PDMP-Step-by-Step-User-Guide.pdf`,
        label: "Document",
      },
    ],
    videos: [
      {
        videoId: "FIkNa4wJccQ",
        label: "Video",
      },
    ],
  },
  {
    title: "EPCS Queue User Manual v3.0",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/DigitalRx-EPCSQueueUserManual-v3.0.pdf`,
        label: "Document",
      },
    ],
    videos: [
      {
        videoId: "7SX5Hs6Y4mA",
        label: "Video",
      },
    ],
  },
  {
    title: "EPA User Manual v3.0",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/DigitalRx-EPAUserManual-v3.0.pdf`,
        label: "Document",
      },
    ],
    videos: [
      {
        videoId: "UomYb1rkiIo",
        label: "Video",
      },
    ],
  },
  {
    title: "Post Dated Prescription User Manual v3.0",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/DigitalRx-PostDatedPrescriptionUserManual-v3.0.pdf`,
        label: "Document",
      },
    ],
    videos: [
      {
        videoId: "Sx8GHJlG4qQ",
        label: "Video",
      },
    ],
  },
  {
    title: "ID Proofing Enrollment Guide",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/ID%20Proofing_eRx%20Document_V1.0.pdf`,
        label: "ID Proofing for eRx",
      },
      {
        url: `${REPORT_BASE_URL}drx/PDF/ID%20Proofing_EPCS%20Document_V1.0.pdf`,
        label: "EPCS Enrollment for Already ID Proofed Users",
      },
    ],
  },
  {
    title: "ID.ME Enrollment Guide",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/ID.me_UserGuide_V_3.2.pdf`,
        label: "Document",
      },
    ],
    resources: [
      {
        link: `https://help.id.me/hc/en-us/articles/360017927633-How-do-I-update-my-phone-number-for-MFA-`,
        label: "Register New Mobile Number With ID.ME Account",
      },
    ],
  },
  {
    title: "On Behalf",
    videos: [
      {
        videoId: "tISh8E5dB4o",
        label: "Video",
      },
      {
        videoId: "_rEwuLcv7E4",
        label: "Features",
      },
    ],
  },
  {
    title: "Digital Rx Ticketing System v3.0",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/DigitalRx-TicketingSystemUserManual-v3.0.pdf`,
        label: "Document",
      },
    ],
    videos: [
      {
        videoId: "fOUoqKWAlxc",
        label: "Video",
      },
    ],
  },
  {
    title: "RTF/RTPB User Manual",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/DigitalRx-RTF&RTPBUserManual-v3.0.pdf`,
        label: "Document",
      },
    ],
  },
  {
    title: "DRx Virtual Assistant",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/User_Manual_Drx_Chatbot.pdf`,
        label: "Document",
      },
    ],
    videos: [
      {
        videoId: "NcP_VyhTczM",
        label: "Video",
      },
    ],
  },
  {
    title: "NCPDP V2017071 PBM & SS Med History changes",
    documents: [
      {
        url: `${REPORT_BASE_URL}drx/PDF/H2H-DRX_NCPDP_v2017071_PBM&SSMedHistoryChanges-v2.pdf`,
        label: "Document",
      },
    ],
    videos: [
      {
        videoId: "JuQUSoF2bng",
        label: "Video",
      },
    ],
  },
];

export function HelpCard(props: any) {
  return (
    <HelpCardStyle>
      <Box className="header">
        <Typography
          component="h6"
          color={"primary"}
          variant="subtitle2"
          fontWeight={600}
        >
          {props.title}
        </Typography>
      </Box>
      <Box className="content">{props.content}</Box>{" "}
    </HelpCardStyle>
  );
}

export default function HelpCenter() {
  const [DRxRequestDemoPopup, setDRxRequestDemoPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [videoPopup, setVideoPopup] = useState(false);
  const [videoTitle, setVideoTitle] = useState("");
  const [videoId, setVideoId] = useState("");
  const [demoState, setDemoState] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const handleShowVideoPopup = () => {
    setVideoPopup(true);
  };
  const handleHideVideoPopup = () => {
    setVideoPopup(false);
  };
  const handleShowDRxRequestDemoPopupClick = () => {
    setDRxRequestDemoPopup(true);
  };
  const handleHideDRxRequestDemoPopupClick = () => {
    setDRxRequestDemoPopup(false);
  };

  const submitEmailForDemo = async (values: any) => {
    try {
      setLoading(true);
      const params: any = new URLSearchParams();
      params.append("emailId", values.email);

      const result = await requestForDemoEmailSendAPI(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        handleHideDRxRequestDemoPopupClick();
        setLoading(false);
        setDemoState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
      } else {
        setLoading(false);
        setDemoState((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setLoading(false);
      setDemoState((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  return (
    <>
      <ContentStyle>
        <Grid
          container
          spacing={2}
          justifyContent={"stretch"}
          alignItems={"stretch"}
        >
          <Grid item xs={12} md={6}>
            <Typography component="h6" color="primary" variant="h6">
              Help Center
            </Typography>
          </Grid>
          <Grid item xs={12} md={6} textAlign={"right"}>
            {" "}
            <YSButton
              size="medium"
              color="primary"
              id="submitBtn"
              variant="contained"
              disabled={false}
              type="button"
              children={"Request a Demo"}
              onClick={handleShowDRxRequestDemoPopupClick}
            />
          </Grid>
        </Grid>
        <Box style={{ display: "flex", flexWrap: "wrap" }}>
          <Grid
            container
            spacing={2}
            justifyContent={"stretch"}
            alignItems={"stretch"}
          >
            {HelpCenterData.map((data: any) => (
              <Grid key={data?.title} item xs={12} md={6}>
                <HelpCard
                  title={data?.title}
                  content={
                    <>
                      <Grid container xs={12} spacing={1}>
                        {data?.documents?.length > 0
                          ? data?.documents?.map((doc: any) => (
                              <>
                                <Grid item xs={6} md={7} lg={8}>
                                  <Typography component="div" variant="body2">
                                    {doc?.label}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={5} lg={4}>
                                  <YSButton
                                    size="small"
                                    className="w150"
                                    color="primary"
                                    id="submitBtn"
                                    variant="outlined"
                                    disabled={false}
                                    type="button"
                                    children={"Download"}
                                    onClick={() => {
                                      window.open(doc?.url, "pdf");
                                    }}
                                    startIcon={<FileDownloadIcon />}
                                  />
                                </Grid>
                              </>
                            ))
                          : null}
                        {data?.videos?.length > 0
                          ? data?.videos?.map((v: any) => (
                              <>
                                <Grid item xs={6} md={7} lg={8}>
                                  <Typography component="div" variant="body2">
                                    {v?.label}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={5} lg={4}>
                                  <YSButton
                                    size="small"
                                    className="w150"
                                    color="primary"
                                    id="submitBtn"
                                    variant="outlined"
                                    disabled={false}
                                    type="button"
                                    children={"Click to View"}
                                    onClick={() => {
                                      setVideoId(v?.videoId);
                                      setVideoTitle(data?.title);
                                      handleShowVideoPopup();
                                    }}
                                    startIcon={<VideocamIcon />}
                                  />
                                </Grid>
                              </>
                            ))
                          : null}
                        {data?.resources?.length > 0
                          ? data?.resources?.map((res: any) => (
                              <>
                                <Grid item xs={6} md={7} lg={8}>
                                  <Typography component="div" variant="body2">
                                    {res?.label}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} md={5} lg={4}>
                                  <YSButton
                                    size="small"
                                    className="w150"
                                    color="primary"
                                    id="submitBtn"
                                    variant="outlined"
                                    disabled={false}
                                    type="button"
                                    children={"Resource"}
                                    onClick={() => {
                                      window.open(`${res?.link}`, "url");
                                    }}
                                    startIcon={<LinkIcon />}
                                  />
                                </Grid>
                              </>
                            ))
                          : null}
                      </Grid>
                    </>
                  }
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </ContentStyle>
      {/* Request a DEMO Popup */}
      <DialogPopup
        windowsize={"sm"}
        show={DRxRequestDemoPopup}
        handleShowPopupClick={handleShowDRxRequestDemoPopupClick}
        handleHidePopupClick={handleHideDRxRequestDemoPopupClick}
        title={"Request a Demo"}
      >
        <Formik
          initialValues={{
            email: "",
          }}
          onSubmit={async (values) => {
            submitEmailForDemo(values);
          }}
        >
          <Form>
            <Grid
              container
              spacing={2}
              justifyContent={"center"}
              alignItems={"center"}
              marginTop={1}
            >
              <Grid item xs={12} md={8} textAlign={"left"}>
                <Typography
                  component={"div"}
                  variant="subtitle2"
                  fontWeight={600}
                >
                  Please enter your email address{" "}
                </Typography>
              </Grid>
              <Grid item xs={12} md={8} textAlign={"center"}>
                <DRxInput id="email" name="email" type="text" className="" />
              </Grid>
              <Grid item xs={12} md={8} textAlign={"left"}>
                <YSButton
                  size="large"
                  color="primary"
                  id="submitBtn"
                  variant="contained"
                  disabled={false}
                  type="submit"
                  children={
                    loading ? (
                      <CircularProgress color="inherit" size={28} />
                    ) : (
                      "Submit"
                    )
                  }
                />
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </DialogPopup>
      {/* Video Popup */}
      <DialogPopup
        windowsize={"md"}
        show={videoPopup}
        title={videoTitle}
        handleShowPopupClick={handleShowVideoPopup}
        handleHidePopupClick={handleHideVideoPopup}
        close={true}
      >
        <Grid container spacing={0}>
          <Grid item xs={12} textAlign="center" marginTop={0}>
            <Grid item xs={12}>
              <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                height="430px"
                width="860px"
                title="Video"
                style={{ border: 0, borderRadius: 5 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogPopup>
      <YSSnackBar
        message={demoState.message}
        variant={demoState.variant}
        open={demoState.open}
        handleClose={() => {
          setDemoState((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
